export enum NOTIFICATION_THEME {
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info',
}

export enum NOTIFICATION_TYPE {
    WITH_ACTION = 'with-action',
    COMMON = 'common',
    WITH_HEADER = 'with-header',
}
